import React, { useEffect, useState, useRef } from "react";
import { secretKey, monthData } from "../.././data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import LoadingPopup from "../helpers/loading_component.js";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const SellGenerateAnalysis = (props) => {
  const [loading, setLoading] = useState(true);
  const [leadName, setLeadName] = useState(props.lead.name);
  const [agreement, setAgreement] = useState(props.lead.creditAgreement);
  const [agreementData, setAgreementData] = useState([]);
  const [comission, setComission] = useState(0);
  const [ammount, setAmmount] = useState(props.lead.creditAmmount);
  const [currency, setCurrency] = useState(
    props.lead.type === "SKD" ? "PLN" : props.lead.creditCurrency
  );
  const [creditDate, setCreditDate] = useState(props.lead.creditDate);
  const [creditMargin, setCreditMargin] = useState("0");
  const [wiborType, setWiborType] = useState("Wibor 3M");
  const [creditTypeText, setCreditTypeText] = useState("kredyt");
  const [creditLength, setCreditLength] = useState("0");
  const [creditType, setCreditType] = useState("równe");
  const [creditSpread, setCreditSpread] = useState("3");
  const [creditCarrency, setCreditCarrency] = useState("0");
  const [creditLengthChange, setCreditLengthChange] = useState([]);
  const [creditLengthChangeOneDate, setCreditLengthChangeOneDate] =
    useState("");
  const [creditLengthChangeOneValue, setCreditLengthChangeOneValue] =
    useState("");
  const [creditMarginChange, setCreditMarginChange] = useState([]);
  const [creditMarginChangeOneDate, setCreditMarginChangeOneDate] =
    useState("");
  const [creditMarginChangeOneValue, setCreditMarginChangeOneValue] =
    useState("");
  const [creditAdditionalTranchesChange, setCreditAdditionalTranchesChange] =
    useState([]);
  const [
    creditAdditionalTranchesChangeOneDate,
    setCreditAdditionalTranchesChangeOneDate,
  ] = useState("");
  const [
    creditAdditionalTranchesChangeOneValue,
    setCreditAdditionalTranchesChangeOneValue,
  ] = useState("");
  const [
    creditAdditionalTranchesChangeOneCurrency,
    setCreditAdditionalTranchesChangeOneCurrency,
  ] = useState("PLN");
  const [creditEarlyPayChange, setCreditEarlyPayChange] = useState([]);
  const [creditEarlyPayChangeOneDate, setCreditEarlyPayChangeOneDate] =
    useState("");
  const [creditEarlyPayChangeOneValue, setCreditEarlyPayChangeOneValue] =
    useState("");
  const [creditEarlyPayChangeOneCurrency, setCreditEarlyPayChangeOneCurrency] =
    useState("PLN");
  const [creditEndDate, setCreditEndDate] = useState("");
  const [analysisType, setAnalysisType] = useState(
    props.lead.type === "CHF"
      ? "chf"
      : props.lead.type === "EURO"
      ? "eur"
      : props.lead.type === "USD"
      ? " dol"
      : props.lead.type === "SKD"
      ? "skd"
      : "chf"
  );
  const [analysisScript, setAnalysisScript] = useState("");
  const [analysisTemplate, setAnalysisTemplate] = useState("");
  const [analysisFolder, setAnalysisFolder] = useState("");
  const [agreementPoints, setAgreementPoints] = useState([]);
  const [agreementPointsText, setAgreementPointsText] = useState("");
  const [judgmentsList, setJudgmentsList] = useState([]);
  const [additional, setAdditional] = useState(false);
  const [editPoints, setEditPoints] = useState(false);
  const [banks, setBanks] = useState([]);
  const [banksOptions, setBanksOptions] = useState([]);
  const [leadBankIn, setLeadBankIn] = useState(props.lead.bank);

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const fetchSellAgreement = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellAgreement", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAgreementData(data);
        fetchScript();
      })
      .catch((error) => {});
  };

  const fetchScript = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getAnalysisScript", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAnalysisScript(data[0].value);
        if (props.lead.type !== "SKD") {
          setAnalysisTemplate(data[0].template);
        } else {
          setAnalysisTemplate("1Qx2fMFjdLhAiFpFHlA86WkHvjHpq5w-2kt_nwygEPWs");
        }

        setAnalysisFolder(data[0].folder);
        fetchAgreementPoint();
      })
      .catch((error) => {});
  };

  const fetchAgreementPoint = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getAgreementPoints", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAgreementPoints(data);
        setAgreementPointsText(
          generateAgreementPointsValueData(props.lead.creditAgreement, data)
        );
        fetchJudgments();
      })
      .catch((error) => {});
  };

  const fetchJudgments = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/judgmentsCompany?companyId=" +
        encodeURI("10")
    )
      .then((response) => response.json())
      .then((data) => {
        setJudgmentsList(
          data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
        );
        fetchBanks();
      });
  };

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        setBanksOptions(createBankOptions(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchSellAgreement();
  };

  useEffect(() => {
    getData();
  }, []);

  const getBanksForTeam = (data) => {
    var usersForTeam = [];

    data.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === 1).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const createBankOptions = (data) => {
    var banksOptions = [];
    getBanksForTeam(data).map((el) => {
      banksOptions.push({ label: el.name, value: el.name });
    });
    return banksOptions;
  };

  const addCreditLengthChangeRecord = (e) => {
    var record = {
      id: creditLengthChange.length + 1,
      date: creditLengthChangeOneDate,
      value: creditLengthChangeOneValue,
    };

    var clc = creditLengthChange;
    clc.push(record);
    setCreditLengthChange(clc);

    setCreditLengthChangeOneDate("");
    setCreditLengthChangeOneValue("");
  };

  const deleteCreditLengthChangeRecord = (e) => {
    var id = e.target.value;

    var clc = creditLengthChange.filter((e) => +e.id !== +id);
    setCreditLengthChange(clc);
  };

  const addCreditMarginChangeRecord = (e) => {
    var record = {
      id: creditMarginChange.length + 1,
      date: creditMarginChangeOneDate,
      value: creditMarginChangeOneValue,
    };

    var clc = creditMarginChange;
    clc.push(record);
    setCreditMarginChange(clc);

    setCreditMarginChangeOneDate("");
    setCreditMarginChangeOneValue("");
  };

  const deleteCreditMarginChangeRecord = (e) => {
    var id = e.target.value;

    var clc = creditMarginChange.filter((e) => +e.id !== +id);
    setCreditMarginChange(clc);
  };

  const addCreditAdditionalTranchesChangeRecord = (e) => {
    if (
      creditAdditionalTranchesChangeOneDate.length > 0 &&
      creditAdditionalTranchesChangeOneValue > 0
    ) {
      var record = {
        id: creditAdditionalTranchesChange.length + 1,
        date: creditAdditionalTranchesChangeOneDate,
        value: creditAdditionalTranchesChangeOneValue,
        currency: creditAdditionalTranchesChangeOneCurrency,
      };

      var clc = creditAdditionalTranchesChange;
      clc.push(record);
      setCreditAdditionalTranchesChange(clc);

      setCreditAdditionalTranchesChangeOneDate("");
      setCreditAdditionalTranchesChangeOneValue("");
      setCreditAdditionalTranchesChangeOneCurrency("PLN");
    }
  };

  const deleteCreditAdditionalTranchesChangeRecord = (e) => {
    var id = e.target.value;

    var clc = creditAdditionalTranchesChange.filter((e) => +e.id !== +id);
    setCreditAdditionalTranchesChange(clc);
  };

  const addCreditEarlyPayChangeRecord = (e) => {
    if (
      creditEarlyPayChangeOneDate.length > 0 &&
      creditEarlyPayChangeOneValue > 0
    ) {
      var record = {
        id: creditEarlyPayChange.length + 1,
        date: creditEarlyPayChangeOneDate,
        value: creditEarlyPayChangeOneValue,
        currency: creditEarlyPayChangeOneCurrency,
      };

      var clc = creditEarlyPayChange;
      clc.push(record);
      setCreditEarlyPayChange(clc);

      setCreditEarlyPayChangeOneDate("");
      setCreditEarlyPayChangeOneValue("");
      setCreditEarlyPayChangeOneCurrency("PLN");
    }
  };

  const deleteCreditEarlyPayChangeRecord = (e) => {
    var id = e.target.value;

    var clc = creditEarlyPayChange.filter((e) => +e.id !== +id);
    setCreditEarlyPayChange(clc);
  };

  const validateForm = () => {
    if (props.lead.type === "SKD") {
      if (
        !+ammount > 0 ||
        !currency ||
        !creditDate ||
        !+creditMargin > 0 ||
        !+creditLength > 0 ||
        !+creditSpread > 0 ||
        !creditType
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        !+ammount > 0 ||
        !currency ||
        !creditDate ||
        !+creditMargin > 0 ||
        !+creditLength > 0 ||
        !+creditSpread > 0 ||
        !creditType ||
        !agreement
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  const generateAgreementPoints = () => {
    var points = agreementPoints.filter((el) => el.agreement === agreement);
    var pointFinal = "";
    pointFinal = points.map(
      (point) => pointFinal + point.point.replaceAll("_", "\n") + "\n\n"
    );
    var agrText = "";
    pointFinal.map((el) => (agrText = agrText + el));

    return agrText;
  };

  const generateAgreementPointsValue = (value) => {
    var points = agreementPoints.filter((el) => el.agreement === value);
    var pointFinal = "";
    pointFinal = points.map(
      (point) => pointFinal + point.point.replaceAll("_", "\n") + "\n\n"
    );
    var agrText = "";
    pointFinal.map((el) => (agrText = agrText + el));

    return agrText;
  };

  const generateAgreementPointsValueData = (value, data) => {
    var points = data.filter((el) => el.agreement === value);
    var pointFinal = "";
    pointFinal = points.map(
      (point) => pointFinal + point.point.replaceAll("_", "\n") + "\n\n"
    );
    var agrText = "";
    pointFinal.map((el) => (agrText = agrText + el));

    return agrText;
  };

  const generateAnalysis = async (e) => {
    if (!validateForm()) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
      return;
    }

    setLoading(true);

    var options, url;

    var payload = {
      creditTypeText: creditTypeText,
      analysisType: analysisType,
      clientBank: agreement,
      clientName: leadName,
      bankIn: leadBankIn,
      comission: comission,
      clientPhone: props.lead.phone,
      clientMail: props.lead.mail,
      creditCurrency: currency,
      clientCreditValueCHF:
        currency === "CHF" || currency === "EUR" || currency === "USD"
          ? ammount
          : "",
      clientCreditValuePLN: currency === "PLN" ? ammount : "",
      clientCreditStartDate: creditDate,
      clientCreditMargin: creditMargin / 100,
      clientCreditLength: creditLength,
      clientCreditDelayLength: creditCarrency,
      clientCreditSpreadValue: creditSpread / 100,

      clientCreditLengthChangeDate1:
        creditLengthChange.length > 0 ? creditLengthChange[0].date : "",
      clientCreditLengthChangeDate2:
        creditLengthChange.length > 1 ? creditLengthChange[1].date : "",
      clientCreditLengthChangeDate3:
        creditLengthChange.length > 2 ? creditLengthChange[2].date : "",
      clientCreditLengthChangeDate4:
        creditLengthChange.length > 3 ? creditLengthChange[3].date : "",
      clientCreditLengthChangeDate5:
        creditLengthChange.length > 4 ? creditLengthChange[4].date : "",
      clientCreditLengthChangeDate6:
        creditLengthChange.length > 5 ? creditLengthChange[5].date : "",
      clientCreditLengthChangeDate7:
        creditLengthChange.length > 6 ? creditLengthChange[6].date : "",
      clientCreditLengthChangeDate8:
        creditLengthChange.length > 7 ? creditLengthChange[7].date : "",
      clientCreditLengthChangeDate9:
        creditLengthChange.length > 8 ? creditLengthChange[8].date : "",
      clientCreditLengthChangeDate10:
        creditLengthChange.length > 9 ? creditLengthChange[9].date : "",
      clientCreditLengthChangeDate11:
        creditLengthChange.length > 10 ? creditLengthChange[10].date : "",
      clientCreditLengthChangeDate12:
        creditLengthChange.length > 11 ? creditLengthChange[11].date : "",
      clientCreditLengthChangeDate13:
        creditLengthChange.length > 12 ? creditLengthChange[12].date : "",
      clientCreditLengthChangeDate14:
        creditLengthChange.length > 13 ? creditLengthChange[13].date : "",
      clientCreditLengthChangeDate15:
        creditLengthChange.length > 14 ? creditLengthChange[14].date : "",

      clientCreditLengthChangeValue1:
        creditLengthChange.length > 0 ? creditLengthChange[0].value : "",
      clientCreditLengthChangeValue2:
        creditLengthChange.length > 1 ? creditLengthChange[1].value : "",
      clientCreditLengthChangeValue3:
        creditLengthChange.length > 2 ? creditLengthChange[2].value : "",
      clientCreditLengthChangeValue4:
        creditLengthChange.length > 3 ? creditLengthChange[3].value : "",
      clientCreditLengthChangeValue5:
        creditLengthChange.length > 4 ? creditLengthChange[4].value : "",
      clientCreditLengthChangeValue6:
        creditLengthChange.length > 5 ? creditLengthChange[5].value : "",
      clientCreditLengthChangeValue7:
        creditLengthChange.length > 6 ? creditLengthChange[6].value : "",
      clientCreditLengthChangeValue8:
        creditLengthChange.length > 7 ? creditLengthChange[7].value : "",
      clientCreditLengthChangeValue9:
        creditLengthChange.length > 8 ? creditLengthChange[8].value : "",
      clientCreditLengthChangeValue10:
        creditLengthChange.length > 9 ? creditLengthChange[9].value : "",
      clientCreditLengthChangeValue11:
        creditLengthChange.length > 10 ? creditLengthChange[10].value : "",
      clientCreditLengthChangeValue12:
        creditLengthChange.length > 11 ? creditLengthChange[11].value : "",
      clientCreditLengthChangeValue13:
        creditLengthChange.length > 12 ? creditLengthChange[12].value : "",
      clientCreditLengthChangeValue14:
        creditLengthChange.length > 13 ? creditLengthChange[13].value : "",
      clientCreditLengthChangeValue15:
        creditLengthChange.length > 14 ? creditLengthChange[14].value : "",

      clientCreditMarginChangeDate1:
        creditMarginChange.length > 0 ? creditMarginChange[0].date : "",
      clientCreditMarginChangeDate2:
        creditMarginChange.length > 1 ? creditMarginChange[1].date : "",
      clientCreditMarginChangeDate3:
        creditMarginChange.length > 2 ? creditMarginChange[2].date : "",
      clientCreditMarginChangeDate4:
        creditMarginChange.length > 3 ? creditMarginChange[3].date : "",
      clientCreditMarginChangeDate5:
        creditMarginChange.length > 4 ? creditMarginChange[4].date : "",
      clientCreditMarginChangeDate6:
        creditMarginChange.length > 5 ? creditMarginChange[5].date : "",
      clientCreditMarginChangeValue1:
        creditMarginChange.length > 0 ? creditMarginChange[0].value / 100 : "",
      clientCreditMarginChangeValue2:
        creditMarginChange.length > 1 ? creditMarginChange[1].value / 100 : "",
      clientCreditMarginChangeValue3:
        creditMarginChange.length > 2 ? creditMarginChange[2].value / 100 : "",
      clientCreditMarginChangeValue4:
        creditMarginChange.length > 3 ? creditMarginChange[3].value / 100 : "",
      clientCreditMarginChangeValue5:
        creditMarginChange.length > 4 ? creditMarginChange[4].value / 100 : "",
      clientCreditMarginChangeValue6:
        creditMarginChange.length > 5 ? creditMarginChange[5].value / 100 : "",
      clientCreditMarginChangeValue7:
        creditMarginChange.length > 6 ? creditMarginChange[6].value / 100 : "",
      clientCreditMarginChangeValue8:
        creditMarginChange.length > 7 ? creditMarginChange[7].value / 100 : "",
      clientCreditMarginChangeValue9:
        creditMarginChange.length > 8 ? creditMarginChange[8].value / 100 : "",
      clientCreditMarginChangeValue10:
        creditMarginChange.length > 9 ? creditMarginChange[9].value / 100 : "",
      clientCreditMarginChangeValue11:
        creditMarginChange.length > 10
          ? creditMarginChange[10].value / 100
          : "",
      clientCreditMarginChangeValue12:
        creditMarginChange.length > 11
          ? creditMarginChange[11].value / 100
          : "",
      clientCreditMarginChangeValue13:
        creditMarginChange.length > 12
          ? creditMarginChange[12].value / 100
          : "",
      clientCreditMarginChangeValue14:
        creditMarginChange.length > 13
          ? creditMarginChange[13].value / 100
          : "",
      clientCreditMarginChangeValue15:
        creditMarginChange.length > 14
          ? creditMarginChange[14].value / 100
          : "",

      clientCreditSubsequentsTranchesDate1:
        creditAdditionalTranchesChange.length > 0
          ? creditAdditionalTranchesChange[0].date
          : "",
      clientCreditSubsequentsTranchesDate2:
        creditAdditionalTranchesChange.length > 1
          ? creditAdditionalTranchesChange[1].date
          : "",
      clientCreditSubsequentsTranchesDate3:
        creditAdditionalTranchesChange.length > 2
          ? creditAdditionalTranchesChange[2].date
          : "",
      clientCreditSubsequentsTranchesDate4:
        creditAdditionalTranchesChange.length > 3
          ? creditAdditionalTranchesChange[3].date
          : "",
      clientCreditSubsequentsTranchesDate5:
        creditAdditionalTranchesChange.length > 4
          ? creditAdditionalTranchesChange[4].date
          : "",
      clientCreditSubsequentsTranchesDate6:
        creditAdditionalTranchesChange.length > 5
          ? creditAdditionalTranchesChange[5].date
          : "",
      clientCreditSubsequentsTranchesDate7:
        creditAdditionalTranchesChange.length > 6
          ? creditAdditionalTranchesChange[6].date
          : "",
      clientCreditSubsequentsTranchesDate8:
        creditAdditionalTranchesChange.length > 7
          ? creditAdditionalTranchesChange[7].date
          : "",
      clientCreditSubsequentsTranchesDate9:
        creditAdditionalTranchesChange.length > 8
          ? creditAdditionalTranchesChange[8].date
          : "",
      clientCreditSubsequentsTranchesDate10:
        creditAdditionalTranchesChange.length > 9
          ? creditAdditionalTranchesChange[9].date
          : "",
      clientCreditSubsequentsTranchesDate11:
        creditAdditionalTranchesChange.length > 10
          ? creditAdditionalTranchesChange[10].date
          : "",
      clientCreditSubsequentsTranchesDate12:
        creditAdditionalTranchesChange.length > 11
          ? creditAdditionalTranchesChange[11].date
          : "",
      clientCreditSubsequentsTranchesDate13:
        creditAdditionalTranchesChange.length > 12
          ? creditAdditionalTranchesChange[12].date
          : "",
      clientCreditSubsequentsTranchesDate14:
        creditAdditionalTranchesChange.length > 13
          ? creditAdditionalTranchesChange[13].date
          : "",
      clientCreditSubsequentsTranchesDate15:
        creditAdditionalTranchesChange.length > 14
          ? creditAdditionalTranchesChange[14].date
          : "",

      clientCreditSubsequentsTranchesValuePLN1:
        creditAdditionalTranchesChange.length > 0 &&
        creditAdditionalTranchesChange[0].currency === "PLN"
          ? creditAdditionalTranchesChange[0].value
          : "",
      clientCreditSubsequentsTranchesValuePLN2:
        creditAdditionalTranchesChange.length > 1 &&
        creditAdditionalTranchesChange[1].currency === "PLN"
          ? creditAdditionalTranchesChange[1].value
          : "",
      clientCreditSubsequentsTranchesValuePLN3:
        creditAdditionalTranchesChange.length > 2 &&
        creditAdditionalTranchesChange[2].currency === "PLN"
          ? creditAdditionalTranchesChange[2].value
          : "",
      clientCreditSubsequentsTranchesValuePLN4:
        creditAdditionalTranchesChange.length > 3 &&
        creditAdditionalTranchesChange[3].currency === "PLN"
          ? creditAdditionalTranchesChange[3].value
          : "",
      clientCreditSubsequentsTranchesValuePLN5:
        creditAdditionalTranchesChange.length > 4 &&
        creditAdditionalTranchesChange[4].currency === "PLN"
          ? creditAdditionalTranchesChange[4].value
          : "",
      clientCreditSubsequentsTranchesValuePLN6:
        creditAdditionalTranchesChange.length > 5 &&
        creditAdditionalTranchesChange[5].currency === "PLN"
          ? creditAdditionalTranchesChange[5].value
          : "",
      clientCreditSubsequentsTranchesValuePLN7:
        creditAdditionalTranchesChange.length > 6 &&
        creditAdditionalTranchesChange[6].currency === "PLN"
          ? creditAdditionalTranchesChange[6].value
          : "",
      clientCreditSubsequentsTranchesValuePLN8:
        creditAdditionalTranchesChange.length > 7 &&
        creditAdditionalTranchesChange[7].currency === "PLN"
          ? creditAdditionalTranchesChange[7].value
          : "",
      clientCreditSubsequentsTranchesValuePLN9:
        creditAdditionalTranchesChange.length > 8 &&
        creditAdditionalTranchesChange[8].currency === "PLN"
          ? creditAdditionalTranchesChange[8].value
          : "",
      clientCreditSubsequentsTranchesValuePLN10:
        creditAdditionalTranchesChange.length > 9 &&
        creditAdditionalTranchesChange[9].currency === "PLN"
          ? creditAdditionalTranchesChange[9].value
          : "",
      clientCreditSubsequentsTranchesValuePLN11:
        creditAdditionalTranchesChange.length > 10 &&
        creditAdditionalTranchesChange[10].currency === "PLN"
          ? creditAdditionalTranchesChange[10].value
          : "",
      clientCreditSubsequentsTranchesValuePLN12:
        creditAdditionalTranchesChange.length > 11 &&
        creditAdditionalTranchesChange[11].currency === "PLN"
          ? creditAdditionalTranchesChange[11].value
          : "",
      clientCreditSubsequentsTranchesValuePLN13:
        creditAdditionalTranchesChange.length > 12 &&
        creditAdditionalTranchesChange[12].currency === "PLN"
          ? creditAdditionalTranchesChange[12].value
          : "",
      clientCreditSubsequentsTranchesValuePLN14:
        creditAdditionalTranchesChange.length > 13 &&
        creditAdditionalTranchesChange[13].currency === "PLN"
          ? creditAdditionalTranchesChange[13].value
          : "",
      clientCreditSubsequentsTranchesValuePLN15:
        creditAdditionalTranchesChange.length > 14 &&
        creditAdditionalTranchesChange[14].currency === "PLN"
          ? creditAdditionalTranchesChange[14].value
          : "",

      clientCreditSubsequentsTranchesValueCHF1:
        creditAdditionalTranchesChange.length > 0 &&
        creditAdditionalTranchesChange[0].currency === currency
          ? creditAdditionalTranchesChange[0].value
          : "",
      clientCreditSubsequentsTranchesValueCHF2:
        creditAdditionalTranchesChange.length > 1 &&
        creditAdditionalTranchesChange[1].currency === currency
          ? creditAdditionalTranchesChange[1].value
          : "",
      clientCreditSubsequentsTranchesValueCHF3:
        creditAdditionalTranchesChange.length > 2 &&
        creditAdditionalTranchesChange[2].currency === currency
          ? creditAdditionalTranchesChange[2].value
          : "",
      clientCreditSubsequentsTranchesValueCHF4:
        creditAdditionalTranchesChange.length > 3 &&
        creditAdditionalTranchesChange[3].currency === currency
          ? creditAdditionalTranchesChange[3].value
          : "",
      clientCreditSubsequentsTranchesValueCHF5:
        creditAdditionalTranchesChange.length > 4 &&
        creditAdditionalTranchesChange[4].currency === currency
          ? creditAdditionalTranchesChange[4].value
          : "",
      clientCreditSubsequentsTranchesValueCHF6:
        creditAdditionalTranchesChange.length > 5 &&
        creditAdditionalTranchesChange[5].currency === currency
          ? creditAdditionalTranchesChange[5].value
          : "",
      clientCreditSubsequentsTranchesValueCHF7:
        creditAdditionalTranchesChange.length > 6 &&
        creditAdditionalTranchesChange[6].currency === currency
          ? creditAdditionalTranchesChange[6].value
          : "",
      clientCreditSubsequentsTranchesValueCHF8:
        creditAdditionalTranchesChange.length > 7 &&
        creditAdditionalTranchesChange[7].currency === currency
          ? creditAdditionalTranchesChange[7].value
          : "",
      clientCreditSubsequentsTranchesValueCHF9:
        creditAdditionalTranchesChange.length > 8 &&
        creditAdditionalTranchesChange[8].currency === currency
          ? creditAdditionalTranchesChange[8].value
          : "",
      clientCreditSubsequentsTranchesValueCHF10:
        creditAdditionalTranchesChange.length > 9 &&
        creditAdditionalTranchesChange[9].currency === currency
          ? creditAdditionalTranchesChange[9].value
          : "",
      clientCreditSubsequentsTranchesValueCHF11:
        creditAdditionalTranchesChange.length > 10 &&
        creditAdditionalTranchesChange[10].currency === currency
          ? creditAdditionalTranchesChange[10].value
          : "",
      clientCreditSubsequentsTranchesValueCHF12:
        creditAdditionalTranchesChange.length > 11 &&
        creditAdditionalTranchesChange[11].currency === currency
          ? creditAdditionalTranchesChange[11].value
          : "",
      clientCreditSubsequentsTranchesValueCHF13:
        creditAdditionalTranchesChange.length > 12 &&
        creditAdditionalTranchesChange[12].currency === currency
          ? creditAdditionalTranchesChange[12].value
          : "",
      clientCreditSubsequentsTranchesValueCHF14:
        creditAdditionalTranchesChange.length > 13 &&
        creditAdditionalTranchesChange[13].currency === currency
          ? creditAdditionalTranchesChange[13].value
          : "",
      clientCreditSubsequentsTranchesValueCHF15:
        creditAdditionalTranchesChange.length > 14 &&
        creditAdditionalTranchesChange[14].currency === currency
          ? creditAdditionalTranchesChange[14].value
          : "",

      clientCreditEarlyRepaymentDate1:
        creditEarlyPayChange.length > 0 ? creditEarlyPayChange[0].date : "",
      clientCreditEarlyRepaymentDate2:
        creditEarlyPayChange.length > 1 ? creditEarlyPayChange[1].date : "",
      clientCreditEarlyRepaymentDate3:
        creditEarlyPayChange.length > 2 ? creditEarlyPayChange[2].date : "",
      clientCreditEarlyRepaymentDate4:
        creditEarlyPayChange.length > 3 ? creditEarlyPayChange[3].date : "",
      clientCreditEarlyRepaymentDate5:
        creditEarlyPayChange.length > 4 ? creditEarlyPayChange[4].date : "",
      clientCreditEarlyRepaymentDate6:
        creditEarlyPayChange.length > 5 ? creditEarlyPayChange[5].date : "",
      clientCreditEarlyRepaymentDate7:
        creditEarlyPayChange.length > 6 ? creditEarlyPayChange[6].date : "",
      clientCreditEarlyRepaymentDate8:
        creditEarlyPayChange.length > 7 ? creditEarlyPayChange[7].date : "",
      clientCreditEarlyRepaymentDate9:
        creditEarlyPayChange.length > 8 ? creditEarlyPayChange[8].date : "",
      clientCreditEarlyRepaymentDate10:
        creditEarlyPayChange.length > 9 ? creditEarlyPayChange[9].date : "",
      clientCreditEarlyRepaymentDate11:
        creditEarlyPayChange.length > 10 ? creditEarlyPayChange[10].date : "",
      clientCreditEarlyRepaymentDate12:
        creditEarlyPayChange.length > 11 ? creditEarlyPayChange[11].date : "",
      clientCreditEarlyRepaymentDate13:
        creditEarlyPayChange.length > 12 ? creditEarlyPayChange[12].date : "",
      clientCreditEarlyRepaymentDate14:
        creditEarlyPayChange.length > 13 ? creditEarlyPayChange[13].date : "",
      clientCreditEarlyRepaymentDate15:
        creditEarlyPayChange.length > 14 ? creditEarlyPayChange[14].date : "",

      clientCreditEarlyRepaymentValuePLN1:
        creditEarlyPayChange.length > 0 &&
        creditEarlyPayChange[0].currency === "PLN"
          ? creditEarlyPayChange[0].value
          : "",
      clientCreditEarlyRepaymentValuePLN2:
        creditEarlyPayChange.length > 1 &&
        creditEarlyPayChange[1].currency === "PLN"
          ? creditEarlyPayChange[1].value
          : "",
      clientCreditEarlyRepaymentValuePLN3:
        creditEarlyPayChange.length > 2 &&
        creditEarlyPayChange[2].currency === "PLN"
          ? creditEarlyPayChange[2].value
          : "",
      clientCreditEarlyRepaymentValuePLN4:
        creditEarlyPayChange.length > 3 &&
        creditEarlyPayChange[3].currency === "PLN"
          ? creditEarlyPayChange[3].value
          : "",
      clientCreditEarlyRepaymentValuePLN5:
        creditEarlyPayChange.length > 4 &&
        creditEarlyPayChange[4].currency === "PLN"
          ? creditEarlyPayChange[4].value
          : "",
      clientCreditEarlyRepaymentValuePLN6:
        creditEarlyPayChange.length > 5 &&
        creditEarlyPayChange[5].currency === "PLN"
          ? creditEarlyPayChange[5].value
          : "",
      clientCreditEarlyRepaymentValuePLN7:
        creditEarlyPayChange.length > 6 &&
        creditEarlyPayChange[6].currency === "PLN"
          ? creditEarlyPayChange[6].value
          : "",
      clientCreditEarlyRepaymentValuePLN8:
        creditEarlyPayChange.length > 7 &&
        creditEarlyPayChange[7].currency === "PLN"
          ? creditEarlyPayChange[7].value
          : "",
      clientCreditEarlyRepaymentValuePLN9:
        creditEarlyPayChange.length > 8 &&
        creditEarlyPayChange[8].currency === "PLN"
          ? creditEarlyPayChange[8].value
          : "",
      clientCreditEarlyRepaymentValuePLN10:
        creditEarlyPayChange.length > 9 &&
        creditEarlyPayChange[9].currency === "PLN"
          ? creditEarlyPayChange[9].value
          : "",
      clientCreditEarlyRepaymentValuePLN11:
        creditEarlyPayChange.length > 10 &&
        creditEarlyPayChange[10].currency === "PLN"
          ? creditEarlyPayChange[10].value
          : "",
      clientCreditEarlyRepaymentValuePLN12:
        creditEarlyPayChange.length > 11 &&
        creditEarlyPayChange[11].currency === "PLN"
          ? creditEarlyPayChange[11].value
          : "",
      clientCreditEarlyRepaymentValuePLN13:
        creditEarlyPayChange.length > 12 &&
        creditEarlyPayChange[12].currency === "PLN"
          ? creditEarlyPayChange[12].value
          : "",
      clientCreditEarlyRepaymentValuePLN14:
        creditEarlyPayChange.length > 13 &&
        creditEarlyPayChange[13].currency === "PLN"
          ? creditEarlyPayChange[13].value
          : "",
      clientCreditEarlyRepaymentValuePLN15:
        creditEarlyPayChange.length > 14 &&
        creditEarlyPayChange[14].currency === "PLN"
          ? creditEarlyPayChange[14].value
          : "",

      clientCreditEarlyRepaymentValueCHF1:
        creditEarlyPayChange.length > 0 &&
        creditEarlyPayChange[0].currency === currency
          ? creditEarlyPayChange[0].value
          : "",
      clientCreditEarlyRepaymentValueCHF2:
        creditEarlyPayChange.length > 1 &&
        creditEarlyPayChange[1].currency === currency
          ? creditEarlyPayChange[1].value
          : "",
      clientCreditEarlyRepaymentValueCHF3:
        creditEarlyPayChange.length > 2 &&
        creditEarlyPayChange[2].currency === currency
          ? creditEarlyPayChange[2].value
          : "",
      clientCreditEarlyRepaymentValueCHF4:
        creditEarlyPayChange.length > 3 &&
        creditEarlyPayChange[3].currency === currency
          ? creditEarlyPayChange[3].value
          : "",
      clientCreditEarlyRepaymentValueCHF5:
        creditEarlyPayChange.length > 4 &&
        creditEarlyPayChange[4].currency === currency
          ? creditEarlyPayChange[4].value
          : "",
      clientCreditEarlyRepaymentValueCHF6:
        creditEarlyPayChange.length > 5 &&
        creditEarlyPayChange[5].currency === currency
          ? creditEarlyPayChange[5].value
          : "",
      clientCreditEarlyRepaymentValueCHF7:
        creditEarlyPayChange.length > 6 &&
        creditEarlyPayChange[6].currency === currency
          ? creditEarlyPayChange[6].value
          : "",
      clientCreditEarlyRepaymentValueCHF8:
        creditEarlyPayChange.length > 7 &&
        creditEarlyPayChange[7].currency === currency
          ? creditEarlyPayChange[7].value
          : "",
      clientCreditEarlyRepaymentValueCHF9:
        creditEarlyPayChange.length > 8 &&
        creditEarlyPayChange[8].currency === currency
          ? creditEarlyPayChange[8].value
          : "",
      clientCreditEarlyRepaymentValueCHF10:
        creditEarlyPayChange.length > 9 &&
        creditEarlyPayChange[9].currency === currency
          ? creditEarlyPayChange[9].value
          : "",
      clientCreditEarlyRepaymentValueCHF11:
        creditEarlyPayChange.length > 10 &&
        creditEarlyPayChange[10].currency === currency
          ? creditEarlyPayChange[10].value
          : "",
      clientCreditEarlyRepaymentValueCHF12:
        creditEarlyPayChange.length > 11 &&
        creditEarlyPayChange[11].currency === currency
          ? creditEarlyPayChange[11].value
          : "",
      clientCreditEarlyRepaymentValueCHF13:
        creditEarlyPayChange.length > 12 &&
        creditEarlyPayChange[12].currency === currency
          ? creditEarlyPayChange[12].value
          : "",
      clientCreditEarlyRepaymentValueCHF14:
        creditEarlyPayChange.length > 13 &&
        creditEarlyPayChange[13].currency === currency
          ? creditEarlyPayChange[13].value
          : "",
      clientCreditEarlyRepaymentValueCHF15:
        creditEarlyPayChange.length > 14 &&
        creditEarlyPayChange[14].currency === currency
          ? creditEarlyPayChange[14].value
          : "",

      analysisAuthor: props.user,
      clientCreditAgreementPoints: agreementPointsText,
      dateCancelCredit: creditEndDate,
      creditType: creditType,
      expertMail: "it@ftpeople.pl",
      clientTemplateID: analysisTemplate,
      clientFolderID: analysisFolder,
      companyID: "10",
      analysisJudgmentsList: judgmentsList,
      clientBankName: props.lead.bank,
      creditTypeText: "kredyt",
      wiborType: wiborType,
      constRemainedDebtValue: "",
      offerType: "",
      guarantee: "",
      costs: "",
    };

    url = analysisScript;

    props.generateAnalysis(payload, props.lead.id, analysisScript);
    props.close();
  };

  const changeAgreement = (e) => {
    setAgreement(e.target.value);
    var points = "";
    if (analysisType === "chf") {
      setAgreementPointsText(generateAgreementPointsValue(e.target.value));
    } else if (analysisType === "eur") {
      setAgreementPointsText(
        generateAgreementPointsValue(e.target.value).replaceAll("CHF", "EUR")
      );
    } else if (analysisType === "usd") {
      setAgreementPointsText(
        generateAgreementPointsValue(e.target.value).replaceAll("CHF", "USD")
      );
    } else {
      setAgreementPointsText(generateAgreementPointsValue(e.target.value));
    }
  };

  return (
    <>
      <div style={{ width: "100%", marginBottom: "1vh" }} className="closeBox">
        <button className="closeClientButton" onClick={props.close}>
          X
        </button>
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div style={{ display: "flex", marginTop: "3vh" }}>
              <div
                style={{
                  width: "20%",
                  textAlign: "left",
                  textTransform: "uppercase",
                  fontSize: "1.5vw",
                  fontWeight: 600,
                }}
              >
                Dane podstawowe
              </div>
              <div
                style={{ width: "80%", display: "flex", alignItems: "center" }}
              >
                <hr style={{ width: "100%" }} />
              </div>
            </div>
            <div
              className="inputBox"
              style={{ marginTop: "5vh", textAlign: "left" }}
            >
              <div className="inputCol_3">
                <label>
                  Imię i nazwisko <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={leadName}
                  onChange={(e) => {
                    setLeadName(e.target.value);
                  }}
                />
              </div>
              <div className="inputCol_3">
                <label>Bank</label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  value={
                    leadBankIn === ""
                      ? { label: "Wybierz...", value: "" }
                      : { label: leadBankIn, value: leadBankIn }
                  }
                  options={banksOptions}
                  onChange={(e) => {
                    setLeadBankIn(e.value);
                  }}
                />
              </div>
            </div>
            {props.lead.type !== "SKD" ? (
              <>
                <div className="inputBox">
                  <div style={{ width: "99%" }} className="inputCol_2">
                    <label>
                      Umowa kredytowa <span className="requiredStar">*</span>
                    </label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      id="name"
                      name="name"
                      value={agreement}
                      onChange={changeAgreement}
                    >
                      {agreement === "" ? (
                        <>
                          <option key={9999} value={""}>
                            {"Wybierz..."}
                          </option>
                        </>
                      ) : (
                        ""
                      )}
                      {agreementData.map((el) => (
                        <>
                          <option key={el.id} value={el.agreement}>
                            {el.agreement}
                          </option>
                        </>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="inputBox">
                  <button
                    style={{ width: "30%" }}
                    className="paymentMenuButton"
                    onClick={(e) => setEditPoints(!editPoints)}
                  >
                    {editPoints
                      ? "Ukryj klauzule abuzywne"
                      : "Pokaż klauzule abuzywne"}
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            {editPoints ? (
              <>
                <div className="inputBox">
                  <div className="inputCol_1">
                    <label>Klauzule abuzywne</label>
                    <textarea
                      spellCheck="false"
                      className="textAreaNote"
                      type="text"
                      id="url"
                      name="url"
                      value={agreementPointsText}
                      onChange={(e) => {
                        setAgreementPointsText(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="inputBox">
              <div className="inputCol_3">
                <label>
                  Kwota kredytu <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={ammount}
                  onChange={(e) => {
                    setAmmount(e.target.value);
                  }}
                  onFocus={(e) => {
                    setAmmount("");
                  }}
                  onKeyPress={checkDigit}
                />
              </div>
              {props.lead.type !== "SKD" ? (
                <div className="inputCol_3">
                  <label>
                    Waluta wypłaty kredytu{" "}
                    <span className="requiredStar">*</span>
                  </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={currency}
                    onChange={(e) => {
                      setCurrency(e.target.value);
                    }}
                  >
                    {currency === "" ? (
                      <>
                        <option key={999} value="">
                          Wybierz...
                        </option>
                      </>
                    ) : (
                      ""
                    )}
                    <option key={0} value="PLN">
                      PLN
                    </option>
                    {analysisType === "chf" ? (
                      <>
                        <option key={1} value="CHF">
                          CHF
                        </option>{" "}
                      </>
                    ) : (
                      ""
                    )}
                    {analysisType === "eur" ? (
                      <>
                        <option key={1} value="EUR">
                          EUR
                        </option>{" "}
                      </>
                    ) : (
                      ""
                    )}
                    {analysisType === "dol" ? (
                      <>
                        <option key={1} value="USD">
                          USD
                        </option>{" "}
                      </>
                    ) : (
                      ""
                    )}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="inputCol_3">
                <label>
                  Data uruchomienia kredytu{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="date"
                  id="name"
                  name="name"
                  value={creditDate}
                  onChange={(e) => {
                    setCreditDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_3">
                <label>
                  Marża kredytu (wyrażona w %){" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={creditMargin}
                  onChange={(e) => {
                    setCreditMargin(e.target.value);
                  }}
                  onFocus={(e) => {
                    setCreditMargin("");
                  }}
                  onKeyPress={checkDigit}
                />
              </div>
              <div className="inputCol_3">
                <label>
                  Okres kredytowania (w miesiącach){" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  style={{ boxSizing: "border-box" }}
                  type="text"
                  id="name"
                  name="name"
                  value={creditLength}
                  onChange={(e) => {
                    setCreditLength(e.target.value);
                  }}
                  onFocus={(e) => {
                    setCreditLength("");
                  }}
                  onKeyPress={checkDigit}
                />
              </div>
            </div>
            <div className="inputBox">
              {props.lead.type === "SKD" ? (
                <div className="inputCol_3">
                  <label>Prowizja</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={comission}
                    onChange={(e) => {
                      setComission(e.target.value);
                    }}
                    onFocus={(e) => {
                      setComission(0);
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="inputBox" style={{ marginBottom: "5vh" }}>
              {props.lead.type === "SKD" ? (
                <>
                  <div className="inputCol_3">
                    <label>Rodzaj wibor</label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      id="name"
                      name="name"
                      value={wiborType}
                      onChange={(e) => {
                        setWiborType(e.target.value);
                      }}
                    >
                      <option key={0} value={"Wibor 1M"}>
                        Wibor 1M
                      </option>
                      <option key={1} value={"Wibor 3M"}>
                        Wibor 3M
                      </option>
                      <option key={2} value={"Wibor 6M"}>
                        Wibor 6M
                      </option>
                      <option key={3} value={"Wibor 12M"}>
                        Wibor 12M
                      </option>
                      <option key={4} value={"Stopa referencyjna"}>
                        Stopa referencyjna
                      </option>
                    </select>
                  </div>
                  <div className="inputCol_3">
                    <label>Rodzaj zobowiąania</label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      id="name"
                      name="name"
                      value={creditTypeText}
                      onChange={(e) => {
                        setCreditTypeText(e.target.value);
                      }}
                    >
                      <option key={0} value={"kredyt"}>
                        kredyt
                      </option>
                      <option key={1} value={"pożyczka"}>
                        pożyczka
                      </option>
                    </select>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>

            <div style={{ display: "flex", marginTop: "5vh" }}>
              <div
                style={{
                  width: "20%",
                  textAlign: "left",
                  textTransform: "uppercase",
                  fontSize: "1.5vw",
                  fontWeight: 600,
                }}
              >
                Dane dodatkowe
              </div>
              <div
                style={{ width: "70%", display: "flex", alignItems: "center" }}
              >
                <hr style={{ width: "100%" }} />
              </div>
              <div
                style={{
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{ width: "80%" }}
                  className="paymentMenuButton"
                  onClick={(e) => setAdditional(!additional)}
                >
                  {additional ? "ZWIŃ" : "ROZWIŃ"}
                </button>
              </div>
            </div>
            <div className={!additional ? "sellHidden" : "sellVisible"}>
              <div className="inputBox" style={{ marginTop: "5vh" }}>
                <div className="inputCol_3">
                  <label>Karencja spłaty kredytu</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditCarrency}
                    onChange={(e) => {
                      setCreditCarrency(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditCarrency("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Data całkowitej spłąty kredytu [jeżeli spłacono]
                  </label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={creditEndDate}
                    onChange={(e) => {
                      setCreditEndDate(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Wysokość spreadu <span className="requiredStar">*</span>
                  </label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditSpread}
                    onChange={(e) => {
                      setCreditSpread(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditSpread("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
              </div>
              <div className="inputBox" style={{ marginBottom: "5vh" }}>
                <div className="inputCol_3">
                  <label>
                    Rodzaj spłaty rat <span className="requiredStar">*</span>
                  </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditType}
                    onChange={(e) => {
                      setCreditType(e.target.value);
                    }}
                  >
                    <option key={0} value="równe">
                      równe
                    </option>
                    <option key={1} value="malejące">
                      malejące
                    </option>
                  </select>
                </div>
              </div>
              <div className="inputBox">
                ZMIANA OKRESU KREDYTOWANIA [max. 15]
              </div>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>Data</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={creditLengthChangeOneDate}
                    onChange={(e) => {
                      setCreditLengthChangeOneDate(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditLengthChangeOneDate("");
                    }}
                  />
                </div>
                <div className="inputCol_3">
                  <label>Wartość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditLengthChangeOneValue}
                    onChange={(e) => {
                      setCreditLengthChangeOneValue(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditLengthChangeOneValue("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
                <div
                  style={{ display: "flex", alignItems: "end" }}
                  className="inputCol_3"
                >
                  <button
                    className="paymentMenuButton"
                    onClick={addCreditLengthChangeRecord}
                  >
                    Dodaj
                  </button>
                </div>
              </div>
              <div className="inputBox">
                {creditLengthChange.length > 0 ? (
                  <>
                    <table
                      style={{ marginTop: "1vh", width: "50%" }}
                      className="clients_table"
                    >
                      <tr key={0}>
                        <th>Lp.</th>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Akcja</th>
                      </tr>
                      {creditLengthChange.map((el) => (
                        <tr>
                          <td style={{ height: "3vh" }}>{el.id}</td>
                          <td style={{ height: "3vh" }}>{el.date}</td>
                          <td style={{ height: "3vh" }}>{el.value}</td>
                          <td style={{ height: "3vh" }}>
                            <button
                              className="paymentMenuButton"
                              value={el.id}
                              onClick={deleteCreditLengthChangeRecord}
                            >
                              Usuń
                            </button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </>
                ) : (
                  <span style={{ fontSize: ".8vw" }}>
                    Brak zmian w tym dziale
                  </span>
                )}
              </div>
              <div className="inputBox">ZMIANA MARŻY [max. 15]</div>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>Data</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={creditMarginChangeOneDate}
                    onChange={(e) => {
                      setCreditMarginChangeOneDate(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_3">
                  <label>Wartość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditMarginChangeOneValue}
                    onChange={(e) => {
                      setCreditMarginChangeOneValue(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditMarginChangeOneValue("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
                <div
                  style={{ display: "flex", alignItems: "end" }}
                  className="inputCol_3"
                >
                  <button
                    className="paymentMenuButton"
                    onClick={addCreditMarginChangeRecord}
                  >
                    Dodaj
                  </button>
                </div>
              </div>
              <div className="inputBox">
                {creditMarginChange.length > 0 ? (
                  <>
                    <table
                      style={{ marginTop: "1vh", width: "50%" }}
                      className="clients_table"
                    >
                      <tr key={0}>
                        <th>Lp.</th>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Akcja</th>
                      </tr>
                      {creditMarginChange.map((el) => (
                        <tr>
                          <td style={{ height: "3vh" }}>{el.id}</td>
                          <td style={{ height: "3vh" }}>{el.date}</td>
                          <td style={{ height: "3vh" }}>{el.value}</td>
                          <td style={{ height: "3vh" }}>
                            <button
                              className="paymentMenuButton"
                              value={el.id}
                              onClick={deleteCreditMarginChangeRecord}
                            >
                              Usuń
                            </button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </>
                ) : (
                  <span style={{ fontSize: ".8vw" }}>
                    Brak zmian w tym dziale
                  </span>
                )}
              </div>
              <div className="inputBox">KOLEJNE TRANSZE KREDYTU [max. 15]</div>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>Data</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={creditAdditionalTranchesChangeOneDate}
                    onChange={(e) => {
                      setCreditAdditionalTranchesChangeOneDate(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_3">
                  <label>Wartość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditAdditionalTranchesChangeOneValue}
                    onChange={(e) => {
                      setCreditAdditionalTranchesChangeOneValue(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditAdditionalTranchesChangeOneValue("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
                {props.lead.type !== "SKD" ? (
                  <div className="inputCol_3">
                    <label>Waluta</label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      id="name"
                      name="name"
                      value={creditAdditionalTranchesChangeOneCurrency}
                      onChange={(e) => {
                        setCreditAdditionalTranchesChangeOneCurrency(
                          e.target.value
                        );
                      }}
                    >
                      <option key={0} value={"PLN"}>
                        PLN
                      </option>
                      {analysisType === "chf" ? (
                        <>
                          <option key={1} value="CHF">
                            CHF
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                      {analysisType === "eur" ? (
                        <>
                          <option key={1} value="EUR">
                            EUR
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                      {analysisType === "dol" ? (
                        <>
                          <option key={1} value="USD">
                            USD
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  </div>
                ) : (
                  ""
                )}
                <div
                  style={{ display: "flex", alignItems: "end" }}
                  className="inputCol_3"
                >
                  <button
                    className="paymentMenuButton"
                    onClick={addCreditAdditionalTranchesChangeRecord}
                  >
                    Dodaj
                  </button>
                </div>
              </div>
              <div className="inputBox">
                {creditAdditionalTranchesChange.length > 0 ? (
                  <>
                    <table
                      style={{ marginTop: "1vh", width: "50%" }}
                      className="clients_table"
                    >
                      <tr key={0}>
                        <th>Lp.</th>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Waluta</th>
                        <th>Akcja</th>
                      </tr>
                      {creditAdditionalTranchesChange.map((el) => (
                        <tr>
                          <td style={{ height: "3vh" }}>{el.id}</td>
                          <td style={{ height: "3vh" }}>{el.date}</td>
                          <td style={{ height: "3vh" }}>{el.value}</td>
                          <td style={{ height: "3vh" }}>{el.currency}</td>
                          <td style={{ height: "3vh" }}>
                            <button
                              className="paymentMenuButton"
                              value={el.id}
                              onClick={
                                deleteCreditAdditionalTranchesChangeRecord
                              }
                            >
                              Usuń
                            </button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </>
                ) : (
                  <span style={{ fontSize: ".8vw" }}>
                    Brak zmian w tym dziale
                  </span>
                )}
              </div>
              <div className="inputBox">
                WCZEŚNIEJSZA SPŁATA KREDYTU [max. 15]
              </div>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>Data</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={creditEarlyPayChangeOneDate}
                    onChange={(e) => {
                      setCreditEarlyPayChangeOneDate(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_3">
                  <label>Wartość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={creditEarlyPayChangeOneValue}
                    onChange={(e) => {
                      setCreditEarlyPayChangeOneValue(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCreditEarlyPayChangeOneValue("");
                    }}
                    onKeyPress={checkDigit}
                  />
                </div>
                {props.lead.type !== "SKD" ? (
                  <div className="inputCol_3">
                    <label>Waluta</label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      id="name"
                      name="name"
                      value={creditEarlyPayChangeOneCurrency}
                      onChange={(e) => {
                        setCreditEarlyPayChangeOneCurrency(e.target.value);
                      }}
                    >
                      <option key={0} value={"PLN"}>
                        PLN
                      </option>
                      {analysisType === "chf" ? (
                        <>
                          <option key={1} value="CHF">
                            CHF
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                      {analysisType === "eur" ? (
                        <>
                          <option key={1} value="EUR">
                            EUR
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                      {analysisType === "dol" ? (
                        <>
                          <option key={1} value="USD">
                            USD
                          </option>{" "}
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  </div>
                ) : (
                  ""
                )}
                <div
                  style={{ display: "flex", alignItems: "end" }}
                  className="inputCol_3"
                >
                  <button
                    className="paymentMenuButton"
                    onClick={addCreditEarlyPayChangeRecord}
                  >
                    Dodaj
                  </button>
                </div>
              </div>
              <div className="inputBox">
                {creditEarlyPayChange.length > 0 ? (
                  <>
                    <table
                      style={{ marginTop: "1vh", width: "50%" }}
                      className="clients_table"
                    >
                      <tr key={0}>
                        <th>Lp.</th>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Waluta</th>
                        <th>Akcja</th>
                      </tr>
                      {creditEarlyPayChange.map((el) => (
                        <tr>
                          <td style={{ height: "3vh" }}>{el.id}</td>
                          <td style={{ height: "3vh" }}>{el.date}</td>
                          <td style={{ height: "3vh" }}>{el.value}</td>
                          <td style={{ height: "3vh" }}>{el.currency}</td>
                          <td style={{ height: "3vh" }}>
                            <button
                              className="paymentMenuButton"
                              value={el.id}
                              onClick={deleteCreditEarlyPayChangeRecord}
                            >
                              Usuń
                            </button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </>
                ) : (
                  <span style={{ fontSize: ".8vw" }}>
                    Brak zmian w tym dziale
                  </span>
                )}
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "5vh" }}>
              <div
                style={{
                  width: "20%",
                  textAlign: "left",
                  textTransform: "uppercase",
                  fontSize: "1.5vw",
                  fontWeight: 600,
                }}
              >
                Wykonaj analizę
              </div>
              <div
                style={{ width: "80%", display: "flex", alignItems: "center" }}
              >
                <hr style={{ width: "100%" }} />
              </div>
            </div>
            <div style={{ marginTop: "5vh" }} className="inputBox">
              <div
                style={{ display: "flex", alignItems: "end" }}
                className="inputCol_3"
              >
                <button
                  style={{ height: "5vh", width: "100%" }}
                  className="paymentMenuButton"
                  onClick={generateAnalysis}
                >
                  Wygeneruj analizę
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SellGenerateAnalysis;
